export default __webpack_public_path__ + "static/banner-bb1a27b3bf5dcb917a35a63916daf151.png";